import { render, staticRenderFns } from "./Dividends.vue?vue&type=template&id=313572f0&"
import script from "./Dividends.vue?vue&type=script&lang=js&"
export * from "./Dividends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports